const Theme = {
  name: 'Villerosemère',

  card_background_color: '',
  card_background_image_url: '',
  card_background_image_repeat: false,
  card_max_width: 0,
  card_text_centered: false,
  card_fullscreen: false,
  card_header_margin_top: 0,

  logo_image_url: 'villerosemere/bandeauweb.jpg',
  header_padding: '0',
  logo_height: 200,
  logo_hidden: false,
  logo_scale: 1,

  token_hidden: true,

  title_font: `Montserrat, medium`,
  title_color: '#293275',

  subtitle_font: `Montserrat, medium`,
  subtitle_color: '#8E2580',
  subtitleH3_color: '#f4a001',
  subtitleH3_font_weight: 700,

  text_font: `Montserrat, medium`,

  // /public/static/background/
  footer_img_top: 'villerosemere/logorosemere.png',
}

export default Theme
